import Switch from '@mui/material/Switch'
import { Box, Checkbox, ListItemText, MenuItem, Select, Typography } from '@mui/material';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useEffect, useState } from 'react'
import { s3 } from '../../constants/awsConfig'
import { showDangerToast } from '../../constants/toaster'
import { useDispatch, useSelector } from 'react-redux'
import { updateLoading } from '../../../redux/features/common/commonSlice'
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';

const label = { inputProps: { 'aria-label': 'Size switch demo' } }

export const AddPackage = (props) => {
    const userData = useSelector(state => state?.userData)
    const [selectedCountryValues, setSelectedCountryValues] = useState([]);
    const [countryDataList, setCountryDataList] = useState([])
    const [allNetworkProviders, setAllNetworkProviders] = useState([]);
    const [selectedNetworkProviderValues, setSelectedNetworkProviderValues] = useState([]);
    const [countryDataListComplete, setCountryDataListComplete] = useState([])
    const dispatch = useDispatch();
    const [imageFile, setImageFile] = useState(null);
    const [image, setImage] = useState(null);
    const [kenyaProductList, setKenyaProductList] = useState([]);
    const [kenyaProductLoading, setKenyaProductLoading] = useState(false);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImageFile(file);
            props?.setPackageFormData({
                ...props?.packageFormData,
                thumbnail: ''
            })
            setImage(URL.createObjectURL(file));
        }
    };

    useEffect(() => {
        setImage(null)
        setImageFile(null)
        if (props?.show) {
            getCountryKeyValuePair()
            if (props?.packageFormData?.country) {
                setSelectedCountryValues(props?.packageFormData?.country)
            }
            if (props?.packageFormData?.networkProviders) {
                setSelectedNetworkProviderValues(props?.packageFormData?.networkProviders)
            }
        }
    }, [props?.show])



    const handleSubmit = async () => {
        let validateSuccess = false;
        if (props?.packageFormData?.id) {
            if (
                props?.packageFormData?.name &&
                props?.packageFormData?.amount &&
                props?.packageFormData?.chips &&
                props?.packageFormData?.duration
            ) {
                if (props?.packageFormData?.noExpiry || props?.packageFormData?.validityDays) {
                    validateSuccess = true;
                } else {
                    showDangerToast("Please fill all required Fields.");
                    validateSuccess = false;
                }

                if (validateSuccess) {
                    if (imageFile) {
                        dispatch(updateLoading(true));
                        const isImageUploaded = await uploadFileToAWS(imageFile);
                        dispatch(updateLoading(false));
                        if (isImageUploaded.success) {
                            props.onSubmit(isImageUploaded.url);
                        } else {
                            showDangerToast("Image upload failed.");
                        }
                    } else {
                        props.onSubmit(props?.packageFormData?.thumbnail);
                    }
                }
            } else {
                showDangerToast("Please fill all required Fields.");
            }
        } else {
            if (
                props?.packageFormData?.name &&
                props?.packageFormData?.amount &&
                props?.packageFormData?.chips &&
                props?.packageFormData?.duration &&
                imageFile
            ) {
                if (props?.packageFormData?.noExpiry || props?.packageFormData?.validityDays) {
                    validateSuccess = true;
                } else {
                    showDangerToast("Please fill all required Fields.");
                    validateSuccess = false;
                }
            } else {
                showDangerToast("Please fill all required Fields.");
                validateSuccess = false;
            }
            if (validateSuccess) {
                dispatch(updateLoading(true));
                const isImageUploaded = await uploadFileToAWS(imageFile);
                dispatch(updateLoading(false));
                if (isImageUploaded.success) {
                    props.onSubmit(isImageUploaded.url);
                } else {
                    showDangerToast("Image upload failed.");
                }
            }
        }
    };

    const handleCountryChange = async (event, type) => {
        if (type === 0) {
            setSelectedCountryValues(event.target.value);
            props?.setPackageFormData({
                ...props?.packageFormData,
                country: event?.target?.value
            })
        } else if (type === 1) {
            setSelectedNetworkProviderValues(event.target.value);
            props?.setPackageFormData({
                ...props?.packageFormData,
                networkProviders: event?.target?.value
            })
        }
    }


    const getCountryKeyValuePair = async () => {
        try {
            dispatch(updateLoading(true))
            let path = urls.countryCodeList
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                let tempArray = []
                for (let i = 0; i < response?.data?.length; i++) {
                    tempArray.push(response?.data?.[i])
                }
                setCountryDataList(tempArray)
                setCountryDataListComplete(response?.data)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }


    const handleNetworkProvidersOpen = async () => {
        try {
            if (!selectedCountryValues?.length) return;

            // Fetch all network providers in parallel
            const responses = await Promise.all(
                selectedCountryValues.map((data) => getCountryNetworkProviderList(data))
            );

            // Flatten the array if each response contains an array
            const mergedProviders = responses.flat();

            // Update state with the new providers
            setAllNetworkProviders(mergedProviders);
            dispatch(updateLoading(false))
            console.log(mergedProviders);
        } catch (error) {
            console.error("Error fetching network providers:", error);
        }
    };


    const getCountryNetworkProviderList = async (id) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.networkProviderKeyValueByCountry + "?countryId=" + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                return response?.data;
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }


    const uploadFileToAWS = async (selectedFile) => {
        if (!selectedFile) return;
        const params = {
            Bucket: 'supa-dev-bucket', // bucket name
            Key: `subscription-thumbnails/${selectedFile.name}`,
            Body: selectedFile,
            ContentType: selectedFile.type,
            // ACL: 'public-read', // Adjust according to your needs
        };

        try {
            const data = await s3.upload(params).promise();
            const url = data.Location.replace(
                "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
                "https://d2up68x544gew2.cloudfront.net/"
            );
            return { success: true, url: url }
        } catch (error) {
            console.error('Error uploading file:', error);
            return { success: false }
        }
    };

    // Helper to check if Kenya is selected (by isnCode === 'KEN')
    const isKenyaSelected = countryDataList.some(
        (c) => c.isnCode === 'KEN' && selectedCountryValues.includes(c.id)
    );

    // Fetch Kenya product list if needed
    useEffect(() => {
        const fetchKenyaProducts = async () => {
            setKenyaProductLoading(true);
            try {
                let path = urls.watchTimeSubscriptionGetAllProduct || '/watch-time-subscription/get-all-product';
                let res = await ApiCaller.get({}, path, userData?.access_token);
                const response = await res.response.json();
                if (response.status == 200) {
                    setKenyaProductList(response.data);
                } else {
                    showDangerToast(response.message);
                }
            } catch (error) {
                showDangerToast(error.message);
            } finally {
                setKenyaProductLoading(false);
            }
        };
        if (isKenyaSelected && props?.packageFormData?.addOnOffer) {
            fetchKenyaProducts();
        } else {
            setKenyaProductList([]);
        }
    }, [isKenyaSelected, props?.packageFormData?.addOnOffer]);


    return <>
        <Modal
            {...props}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className="bg-light">
                <Modal.Title id='contained-modal-title-vcenter' className="text-primary">
                    {props?.packageFormData?.id ? 'Edit Subscription Package' : 'New Subscription Package'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">
                    {/* Basic Information */}
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Basic Information</h6>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Package Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                maxLength={15}
                                                value={props.packageFormData.name}
                                                onChange={(e) => props.setPackageFormData({
                                                    ...props?.packageFormData,
                                                    name: e.target.value
                                                })}
                                                placeholder="Enter package name"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-3">
                                        <Form.Group>
                                            <Form.Label>Amount <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                maxLength={5}
                                                value={props.packageFormData.amount}
                                                onChange={(e) => {
                                                    const numericRegex = /^[0-9\b]+$/
                                                    if (numericRegex.test(e.target.value) || e.target.value === '') {
                                                        props.setPackageFormData({
                                                            ...props?.packageFormData,
                                                            amount: e.target.value
                                                        })
                                                    }
                                                }}
                                                placeholder="Enter amount"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-3">
                                        <Form.Group>
                                            <Form.Label>Chips <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                maxLength={5}
                                                value={props.packageFormData.chips}
                                                onChange={(e) => {
                                                    const numericRegex = /^[0-9\b]+$/
                                                    if (numericRegex.test(e.target.value) || e.target.value === '') {
                                                        props.setPackageFormData({
                                                            ...props?.packageFormData,
                                                            chips: e.target.value
                                                        })
                                                    }
                                                }}
                                                placeholder="Enter chips"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Location Settings */}
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Location Settings</h6>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Countries</Form.Label>
                                            <Select
                                                multiple
                                                value={selectedCountryValues}
                                                onChange={(e) => handleCountryChange(e, 0)}
                                                renderValue={(selected) => `${selected.length} Selected`}
                                                className="w-100"
                                            >
                                                {countryDataList.map((option) => (
                                                    <MenuItem key={option?.name} value={option?.id}>
                                                        <Checkbox checked={selectedCountryValues.indexOf(option?.id) > -1} />
                                                        <ListItemText primary={option?.name} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Network Providers</Form.Label>
                                            <Select
                                                multiple
                                                value={selectedNetworkProviderValues}
                                                onChange={(e) => handleCountryChange(e, 1)}
                                                onOpen={handleNetworkProvidersOpen}
                                                renderValue={(selected) => `${selected.length} Selected`}
                                                className="w-100"
                                            >
                                                {allNetworkProviders.map((option) => (
                                                    <MenuItem key={option?.value} value={option?.key}>
                                                        <Checkbox checked={selectedNetworkProviderValues.indexOf(option?.key) > -1} />
                                                        <ListItemText primary={option?.value} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Duration Settings */}
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Duration Settings</h6>
                                <div className="row g-3 align-items-end">
                                    <div className="col-md-4">
                                        <Form.Group>
                                            <Form.Label>Duration (Seconds) <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                maxLength={10}
                                                value={props.packageFormData.duration}
                                                onChange={(e) => {
                                                    const numericRegex = /^[0-9\b]+$/
                                                    if (numericRegex.test(e.target.value) || e.target.value === '') {
                                                        props.setPackageFormData({
                                                            ...props?.packageFormData,
                                                            duration: e.target.value
                                                        })
                                                    }
                                                }}
                                                placeholder="Enter duration"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-4">
                                        <Form.Group>
                                            <Form.Label>No Expiry</Form.Label>
                                            <div>
                                                <Switch
                                                    {...label}
                                                    checked={props?.packageFormData?.noExpiry}
                                                    onChange={e => props?.setPackageFormData({
                                                        ...props?.packageFormData,
                                                        noExpiry: e?.target?.checked
                                                    })}
                                                    size='small'
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                    {!props?.packageFormData?.noExpiry && (
                                        <div className="col-md-4">
                                            <Form.Group>
                                                <Form.Label>Validity (Days) <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    maxLength={10}
                                                    value={props.packageFormData.validityDays}
                                                    onChange={(e) => {
                                                        const numericRegex = /^[0-9\b]+$/
                                                        if (numericRegex.test(e.target.value) || e.target.value === '') {
                                                            props.setPackageFormData({
                                                                ...props?.packageFormData,
                                                                validityDays: e.target.value
                                                            })
                                                        }
                                                    }}
                                                    placeholder="Enter validity days"
                                                />
                                            </Form.Group>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Thumbnail */}
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Package Thumbnail</h6>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Upload Image</Form.Label>
                                            <input 
                                                type="file" 
                                                accept="image/*" 
                                                onChange={handleImageChange}
                                                className="form-control"
                                            />
                                        </Form.Group>
                                    </div>
                                    {(image || props?.packageFormData?.thumbnail) && (
                                        <div className="col-md-6">
                                            <Form.Label>Preview</Form.Label>
                                            <div className="border rounded p-2">
                                                <img 
                                                    src={props?.packageFormData?.thumbnail || image} 
                                                    alt="Thumbnail"
                                                    style={{ maxHeight: "100px", objectFit: "contain" }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add-on Offers */}
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="card-title mb-0">Add-on Offers</h6>
                                    <Switch
                                        {...label}
                                        checked={props?.packageFormData?.addOnOffer}
                                        onChange={e => props?.setPackageFormData({
                                            ...props?.packageFormData,
                                            addOnOffer: e?.target?.checked
                                        })}
                                        size='small'
                                    />
                                </div>
                                {props?.packageFormData?.addOnOffer && (
                                    <div className="row g-3">
                                        {/* Kenya Product Dropdown */}
                                        {isKenyaSelected ? (
                                            <div className="col-md-6">
                                                <Form.Group>
                                                    <Form.Label>Kenya Product</Form.Label>
                                                    <Select
                                                        value={props.packageFormData.kenyaProductId || ''}
                                                        onChange={e => {
                                                            const selectedProduct = kenyaProductList.find(p => p.product_id === e.target.value);
                                                            props.setPackageFormData({
                                                                ...props.packageFormData,
                                                                kenyaProductId: e.target.value,
                                                                dataBundle: selectedProduct ? selectedProduct.data : ''
                                                            })
                                                        }}
                                                        className="w-100"
                                                        disabled={kenyaProductLoading}
                                                    >
                                                        {kenyaProductList.map((option) => (
                                                            <MenuItem key={option.product_id} value={option.product_id}>
                                                                {option.data} MB
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Form.Group>
                                            </div>
                                        ) : (
                                            <div className="col-md-6">
                                                <Form.Group>
                                                    <Form.Label>Data Bundle (MB)</Form.Label>
                                                    <Form.Control
                                                        maxLength={10}
                                                        value={props.packageFormData.dataBundle}
                                                        onChange={(e) => {
                                                            const numericRegex = /^[0-9\b]+$/
                                                            if (numericRegex.test(e.target.value) || e.target.value === '') {
                                                                props.setPackageFormData({
                                                                    ...props?.packageFormData,
                                                                    dataBundle: e.target.value
                                                                })
                                                            }
                                                        }}
                                                        placeholder="Enter data bundle"
                                                    />
                                                </Form.Group>
                                            </div>
                                        )}
                                        <div className="col-md-6">
                                            <Form.Group>
                                                <Form.Label>Chips Bundle</Form.Label>
                                                <Form.Control
                                                    maxLength={5}
                                                    value={props.packageFormData.chipsBundle}
                                                    onChange={(e) => {
                                                        const numericRegex = /^[0-9\b]+$/
                                                        if (numericRegex.test(e.target.value) || e.target.value === '') {
                                                            props.setPackageFormData({
                                                                ...props?.packageFormData,
                                                                chipsBundle: e.target.value
                                                            })
                                                        }
                                                    }}
                                                    placeholder="Enter chips bundle"
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={props.onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    {props?.packageFormData?.id ? 'Update Package' : 'Create Package'}
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}